import type { ShippingMethod } from '../../typings/basket.types';

const getPreselectedShippingMethodId = (nextShippingMethods: ShippingMethod[], currentMethodId: string): string => {
    if (nextShippingMethods.length === 0) {
        return '';
    }

    const currentMethodIdNumber = Number(currentMethodId);
    const hasCurrentMethod = nextShippingMethods.some(({ id }) => id === currentMethodIdNumber);

    return hasCurrentMethod ? currentMethodId : nextShippingMethods[0].id.toString();
};

export default getPreselectedShippingMethodId;
